module.exports = __webpack_public_path__ + "img/wisteria.4bb70da.svg";